import { useSelector } from 'react-redux';

import { UnleashFeatureNames } from '../../modules/Unleash/featureNames';
import { getFeatureVariant } from '../../selectors/features';
import useIsPaymentPromoEligible from './useIsPaymentPromoEligible';

export default function useGetVipPromoPercentage() {
  const isPaymentPromoEligible = useIsPaymentPromoEligible();
  const variant = useSelector(state =>
    getFeatureVariant(state, UnleashFeatureNames.empAllVipPromo)
  );

  return variant && isPaymentPromoEligible ? parseInt(variant) : null;
}
